import { RegulatoryEffectType } from "~/shared/types/RegulatoryEffect";
import { type OrderRegulatoryFindings, type RegulatoryFinding } from "~/shared/types/RegulatoryFinding";

/** Current, triggered Flag messages are the only client-side acknowledgement candidates. */
export const regulatoryFlagsNeedingAcknowledgement = (findings: readonly RegulatoryFinding[] | undefined): RegulatoryFinding[] =>
  (findings ?? []).filter(
    finding =>
      finding.effectType === RegulatoryEffectType.Flag && finding.status === "INCOMPLETE" && finding.regulatoryWarningMessage !== undefined,
  );

/** The text-only status tooltip consumes the same Block findings rendered with full links in Checks. */
export const getRegulatoryFindingTooltip = (regulatoryFindings: OrderRegulatoryFindings | null | undefined): string => {
  if (!regulatoryFindings?.blocked) {
    return "";
  }

  return regulatoryFindings.findings
    .filter(finding => finding.effectType === RegulatoryEffectType.Block && finding.status === "INCOMPLETE")
    .map(finding =>
      finding.messages.length ? `${finding.title}: ${finding.messages.map(message => message.display).join(", ")}` : finding.title,
    )
    .join("; ");
};
